export class RuleModalScreen {
  private container: HTMLElement | null = null;

  public show(): void {
    if (this.container) {
      this.container.style.display = 'flex';
      return;
    }

    this.container = document.createElement('div');
    this.container.className = 'rule-modal-overlay';
    this.container.innerHTML = `
      <div class="rule-modal-content">
        <button class="rule-modal-close" aria-label="閉じる">&times;</button>
        <h2 class="rule-modal-title">ゲームルール</h2>

        <div class="rule-modal-body">
          <section class="rule-section">
            <h3>🎯 ゲームの目的</h3>
            <p>6つのラウンドをクリアしてゴールを目指そう！</p>
            <div class="pattern-display">
              <span class="pattern-text chim">チム</span>
              <span class="pattern-text chim">チム</span>
              <span class="pattern-text don">ドン</span>
              <span class="pattern-text don">ドン</span>
              <span class="pattern-text chim">チム</span>
              <span class="pattern-text don">ドン</span>
              <span class="pattern-text don">ドン</span>
            </div>
            <p class="rule-note">この順番で7つの丸をタップして、全6ラウンドクリアしよう！</p>
          </section>

          <section class="rule-section">
            <h3>📐 基本ルール</h3>
            <ul class="rule-list">
              <li><strong>隣接移動</strong>: となりのタイルにしか移動できません</li>
              <li><strong>1回だけ</strong>: 同じタイルは1ルート内で1回しか使えません</li>
              <li><strong>全て使う</strong>: タイルの丸は全て使い切る必要があります</li>
              <li><strong>キータイルを通る</strong>: 各ラウンドで黄色い丸で示されるキータイルを必ず通ります</li>
            </ul>
          </section>

          <section class="rule-section">
            <h3>🕳️ トンネル効果</h3>
            <p>中央タイルに隣接するタイル同士は、中央を挟んで<strong>反対側のタイルとも隣接</strong>しているとみなされます。</p>
            <div class="tunnel-diagram">
              <div class="tunnel-hex-grid">
                <div class="tunnel-tile a">A</div>
                <div class="tunnel-tile f">F</div>
                <div class="tunnel-tile b">B</div>
                <div class="tunnel-tile center">中</div>
                <div class="tunnel-tile e">E</div>
                <div class="tunnel-tile c">C</div>
                <div class="tunnel-tile d">D</div>
              </div>
              <div class="tunnel-pairs">
                <div class="tunnel-pair"><span class="pair-a">A</span> ↔ <span class="pair-d">D</span></div>
                <div class="tunnel-pair"><span class="pair-b">B</span> ↔ <span class="pair-e">E</span></div>
                <div class="tunnel-pair"><span class="pair-c">C</span> ↔ <span class="pair-f">F</span></div>
              </div>
            </div>
            <p class="rule-note">中央タイルを挟んで真向かいにあるタイル同士は、トンネルでつながっているように移動できます</p>
          </section>

          <section class="rule-section">
            <h3>⭐ 旗頭タイルの特別ルール</h3>
            <p>キータイル（黄色い丸）と中央タイルの両方に隣接するタイルは「旗頭タイル」になります。</p>
            <ul class="rule-list special">
              <li>1回だけタップできます（丸が複数あっても）</li>
              <li>「チム」か「ドン」、好きな方として使えます</li>
            </ul>
          </section>

          <section class="rule-section">
            <h3>🚫 失敗条件</h3>
            <ul class="rule-list warning">
              <li>隣接していないタイルをタップした</li>
              <li>同じタイルを2回使った</li>
              <li>パターンと違う色をタップした</li>
              <li>タイルの丸を使い切らずに次へ移動した</li>
              <li>キータイルを通らずにクリアしようとした</li>
            </ul>
            <p class="rule-note">失敗すると、そのラウンドは最初からやり直しです</p>
          </section>

          <section class="rule-section">
            <h3>💡 ヒント機能</h3>
            <p>「答えを見る」ボタンで正解ルートを表示できますが、15秒のペナルティが加算されます。</p>
          </section>

          <section class="rule-section">
            <h3>🎉 ゲームクリア</h3>
            <p>全6ラウンドをクリアすると完了！最速タイムを目指そう！</p>
          </section>
        </div>

        <button class="rule-modal-button">閉じる</button>
      </div>
    `;

    document.body.appendChild(this.container);

    // イベントリスナー設定
    const closeBtn = this.container.querySelector('.rule-modal-close');
    const closeButton = this.container.querySelector('.rule-modal-button');
    const overlay = this.container;

    closeBtn?.addEventListener('click', () => this.hide());
    closeButton?.addEventListener('click', () => this.hide());

    // オーバーレイクリックで閉じる（モーダルコンテンツ内のクリックは除外）
    overlay.addEventListener('click', (e) => {
      if (e.target === overlay) {
        this.hide();
      }
    });
  }

  public hide(): void {
    if (this.container) {
      this.container.style.display = 'none';
    }
  }

  public destroy(): void {
    if (this.container) {
      this.container.remove();
      this.container = null;
    }
  }
}
